"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    bytecloudAsyncJwtService: ()=>bytecloudAsyncJwtService
});
const core_lib_namespaceObject = require("@bytecloud/core-lib");
const external_async_jwt_config_js_namespaceObject = require("./async-jwt.config.js");
const external_jwt_init_util_js_namespaceObject = require("./jwt-init-util.js");
const query_config_js_namespaceObject = require("../utils/query.config.js");
const comon_js_namespaceObject = require("../utils/comon.js");
const once_namespaceObject = require("lodash/once");
var once_default = /*#__PURE__*/ __webpack_require__.n(once_namespaceObject);
const bytecloudAsyncJwtService = new core_lib_namespaceObject.AsyncPackagedJwtService({
    getJwtConfig: once_default()(async ()=>{
        const firstConfig = await (0, external_async_jwt_config_js_namespaceObject.getJwtConfig)();
        const { instance: tccProxy, isProd } = (0, external_async_jwt_config_js_namespaceObject.getJwtTccProxy)();
        try {
            tccProxy.on('configChange', (param)=>{
                let { currentConfig } = param;
                const data = currentConfig;
                if (data.jwtItems && data.domainIDToPartition && data.partitionToUniqueKeys) {
                    var _bytecloudAsyncJwtService_onConfigChanged;
                    null == bytecloudAsyncJwtService || null == (_bytecloudAsyncJwtService_onConfigChanged = bytecloudAsyncJwtService.onConfigChanged) || _bytecloudAsyncJwtService_onConfigChanged.call(bytecloudAsyncJwtService, data);
                }
            });
            if (isProd) {
                var _tccProxy_broadcastConfig;
                tccProxy.listenToChannel();
                await (null == (_tccProxy_broadcastConfig = tccProxy.broadcastConfig) ? void 0 : _tccProxy_broadcastConfig.call(tccProxy));
            }
        } catch (error) {
            console.error(error);
        }
        return firstConfig;
    }),
    defaultHostname: 'undefined' != typeof location && location.hostname || void 0,
    promiseCacheObject: (0, external_jwt_init_util_js_namespaceObject.initJwtPromiseCache)(),
    storageGet: external_jwt_init_util_js_namespaceObject.storageGet,
    storageSet: external_jwt_init_util_js_namespaceObject.storageSet,
    ticketQuery: query_config_js_namespaceObject.libInitialQuery.get(query_config_js_namespaceObject.libQueryConfig.jwt_ticket) || void 0
});
const removeJwtTicket = ()=>{
    try {
        if (comon_js_namespaceObject.hasWindow && !(0, query_config_js_namespaceObject.libHasQuery)(query_config_js_namespaceObject.libQueryConfig["skip-remove-jwt-ticket"]) && (0, query_config_js_namespaceObject.libHasQuery)(query_config_js_namespaceObject.libQueryConfig.jwt_ticket)) {
            const urlObj = new URL(window.location.href);
            urlObj.searchParams.delete(query_config_js_namespaceObject.libQueryConfig.jwt_ticket);
            window.history.replaceState(window.history.state || {
                idx: Date.now()
            }, '', urlObj.href);
        }
    } catch (error) {
        console.error(error);
    }
};
removeJwtTicket();
exports.bytecloudAsyncJwtService = __webpack_exports__.bytecloudAsyncJwtService;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "bytecloudAsyncJwtService"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
